import { render } from "./infoIcon.vue?vue&type=template&id=2efc5f2f"
import script from "./infoIcon.vue?vue&type=script&lang=js"
export * from "./infoIcon.vue?vue&type=script&lang=js"

import "./infoIcon.vue?vue&type=style&index=0&id=2efc5f2f&lang=scss"

import exportComponent from "/codebuild/output/src1706908206/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__